"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var R = _interopRequireWildcard(require("ramda"));
var _scale = _interopRequireDefault(require("../run/scale"));
var _resolve = _interopRequireDefault(require("../indices/resolve"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getCharacterSpacing = R.pathOr(0, ['attributes', 'characterSpacing']);
var getAvailableFontFeatures = R.pathOr(0, ['attributes', 'font', 'availableFeatures']);
var isFontFeatureExist = function isFontFeatureExist(run, feature) {
  var availableFontFeatures = getAvailableFontFeatures(run);
  if (!availableFontFeatures) return false;
  return availableFontFeatures.includes(feature);
};
var getFontFeatureTag = function getFontFeatureTag(fontVariant) {
  switch (fontVariant) {
    case 'small-caps':
      return 'smcp';
    default:
      return null;
  }
};
var getFontFeatures = function getFontFeatures(run, fontVariant) {
  var fontFeatureTag = getFontFeatureTag(fontVariant);
  var ignoredFontVariants = ['superscript', 'subscript'];
  if (!fontFeatureTag || fontFeatureTag && !isFontFeatureExist(run, fontFeatureTag) || ignoredFontVariants.includes(fontVariant)) {
    return [];
  }
  return [fontFeatureTag];
};
var transformString = function transformString(runString, fontVariant, fontFeatures) {
  switch (fontVariant) {
    case 'small-caps':
      if (fontFeatures.length === 0) {
        return runString.toUpperCase();
      }
      return runString;
    default:
      return runString;
  }
};

/**
 * Scale run positions
 *
 * @param  {Object}  run
 * @param  {Array}  positions
 * @return {Array} scaled positions
 */
var scalePositions = function scalePositions(run, positions) {
  var multScale = R.multiply((0, _scale.default)(run));
  var characterSpacing = getCharacterSpacing(run);
  var scalePosition = R.evolve({
    xAdvance: R.o(R.add(characterSpacing), multScale),
    yAdvance: multScale,
    xOffset: multScale,
    yOffset: multScale
  });
  var subCharacterSpacing = R.evolve({
    xAdvance: R.subtract(R.__, characterSpacing)
  });
  return R.compose(R.adjust(-1, subCharacterSpacing), R.map(scalePosition))(positions);
};

/**
 * Create glyph run
 *
 * @param  {String}  string
 * @param  {Object}  run
 * @return {Object}  glyph run
 */
var layoutRun = function layoutRun(string) {
  return function (run) {
    var start = run.start,
      end = run.end,
      _run$attributes = run.attributes,
      attributes = _run$attributes === void 0 ? {} : _run$attributes;
    var font = attributes.font,
      fontVariant = attributes.fontVariant;
    if (!font) return (0, _extends2.default)({}, run, {
      glyphs: [],
      glyphIndices: [],
      positions: []
    });
    var runString = string.slice(start, end);
    var fontFeatures = getFontFeatures(run, fontVariant);

    /**
     * Transform string when needed
     * ex: when font do not have font features for fontVarients like `small-caps`
     *     transform text into uppercase
     */
    runString = transformString(runString, fontVariant, fontFeatures);
    var glyphRun = font.layout(runString, fontFeatures);
    var positions = scalePositions(run, glyphRun.positions);
    var glyphIndices = (0, _resolve.default)(glyphRun.glyphs);
    return (0, _extends2.default)({}, run, {
      positions: positions,
      glyphIndices: glyphIndices,
      glyphs: glyphRun.glyphs
    });
  };
};

/**
 * Generate glyphs for single attributed string
 *
 * @param  {Object}  layout engines
 * @param  {Object}  layout options
 * @param  {Array}  attributed strings
 * @return {Array} attributed string with glyphs
 */
var generateGlyphs = function generateGlyphs() {
  return function (attributedString) {
    return R.evolve({
      runs: R.map(layoutRun(attributedString.string))
    })(attributedString);
  };
};
var _default = exports.default = generateGlyphs;